// extracted by mini-css-extract-plugin
export default {"leftNavigation":"CarouselLeftNavigation_leftNavigation__Udtvg"};